import * as React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { styled, css } from "@mui/system";
import { Box, Modal as BaseModal, Button } from "@mui/material";

export function InfoPopup({ handleClose, isOpen, onClick, header, text }) {
  return (
    <Modal
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      open={isOpen}
      onClose={handleClose}
      // slots={{ backdrop: StyledBackdrop }}
    >
      <ModalContent sx={{ width: 400 }}>
        <h2 id="unstyled-modal-title" className="modal-title">
        {header}
        </h2>
        <p id="unstyled-modal-description" className="modal-description">
            {text}
         
        </p>
        <Box className="buttons">
          <Button variant="outlined" onClick={onClick}>
            Yes
          </Button>
          <Button variant="outlined" onClick={handleClose}>
            No
          </Button>
        </Box>
      </ModalContent>
    </Modal>
  );
}

const Backdrop = React.forwardRef((props, ref) => {
  const { open, className, ...other } = props;
  return (
    <div
      className={clsx({ "base-Backdrop-open": open }, className)}
      ref={ref}
      {...other}
    />
  );
});

Backdrop.propTypes = {
  className: PropTypes.string.isRequired,
  open: PropTypes.bool,
};

const Modal = styled(BaseModal)`
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// const StyledBackdrop = styled(Backdrop)`
//   z-index: -1;
//   position: fixed;
//   inset: 0;
//   background-color: rgb(0 0 0 / 0.5);
//   -webkit-tap-highlight-color: transparent;
// `;

const ModalContent = styled("div")(
  ({ theme }) => css`
    font-weight: 500;
    text-align: start;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: hidden;
    background-color:#fff;
    border-radius: 8px;

    padding: 24px;

    & .modal-title {
      margin: 0;
      margin-bottom: 8px;
      font-size: 15px;
      color: #5c088c;
      font-weight: bold;
      text-transform: uppercase;
    }

    & .modal-description {
      margin: 0;
      font-weight: 400;
      margin-bottom: 4px;
    }
    & .buttons {
    display: flex;
    justify-content: center;
    gap:25px;
    },
  `
);
